module.exports = __webpack_public_path__ + "img/arrow-lb.a0b8bbe7.svg";